import {parsePhoneNumber} from 'react-phone-number-input';
import {PhoneNumber} from '../models';

export const convertStringToPhoneNumber = (phoneString: string): PhoneNumber => {
  if (!phoneString) {
    return new PhoneNumber({countryCode: '', phoneNumber: ''});
  }

  try {
    const parsed = parsePhoneNumber(phoneString);
    if (parsed) {
      return new PhoneNumber({
        countryCode: `+${parsed.countryCallingCode}`,
        phoneNumber: parsed.nationalNumber,
      });
    } else {
      return new PhoneNumber({
        countryCode: '',
        phoneNumber: phoneString,
      });
    }
  } catch (error) {
    return new PhoneNumber({
      countryCode: '',
      phoneNumber: phoneString,
    });
  }
};

export const convertPhoneNumberToString = (phoneNumber: PhoneNumber | null | undefined): string => {
  if (!phoneNumber || (!phoneNumber.countryCode && !phoneNumber.phoneNumber)) {
    return '';
  }
  return `${phoneNumber.countryCode}${phoneNumber.phoneNumber}`;
};
